import { useAnalyticContext } from '@application/analytic/analytic_link/mod';
import { withTranslation } from '@application/i18n/with_translation';
import { ActionCard, Stack, Text } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { Shimmer } from '@component/new_shimmer.component';
import type { PaymentServiceApiModel } from '@visiba/api-vcs-client-v2';
import styled from 'styled-components';

interface Props {
	options: PaymentServiceApiModel[];
	onSelect: (item: PaymentServiceApiModel) => void;
}

const elements = {
	actionCardImage: styled.img`
		width: ${tokens.spacing.x4};
		height: ${tokens.spacing.x4};
	`,
};

export function PaymentOptions({ options, onSelect }: Props): JSX.Element {
	const analyticCtx = useAnalyticContext();

	function handleClick(item: PaymentServiceApiModel): () => void {
		return () => {
			analyticCtx.trackEvent(`Selected ${item.Name}`);

			onSelect(item);
		};
	}

	return (
		<Stack gap={tokens.spacing.x1}>
			<Text variant='labelLargeSemiBold'>{withTranslation('PW.Component.Payment.ChoosePayment')}</Text>
			{!options.length ? (
				<Skeleton />
			) : (
				<>
					{options.map((item) => (
						<ActionCard.Root
							key={item.Name}
							icon={<elements.actionCardImage src={item.ImageUrl} alt='' />}
							onClick={handleClick(item)}
							trailingIcon={null}
						>
							<ActionCard.Title>{item.Name}</ActionCard.Title>
						</ActionCard.Root>
					))}
				</>
			)}
		</Stack>
	);
}

function Skeleton() {
	return (
		<>
			<Shimmer height={64} width='100%' />
			<Shimmer height={64} width='100%' />
			<Shimmer height={64} width='100%' />
		</>
	);
}
